var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_4929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.93442 0 0 4.93442 0 11C0 17.0656 4.93442 22 11 22C17.0656 22 22 17.0656 22 11C22 4.93442 17.0656 0 11 0ZM11 20.1667C5.9455 20.1667 1.83333 16.0545 1.83333 11C1.83333 5.9455 5.9455 1.83333 11 1.83333C16.0545 1.83333 20.1667 5.9455 20.1667 11C20.1667 16.0545 16.0545 20.1667 11 20.1667ZM14.6667 12.8333C14.6667 14.3495 13.4328 15.5833 11.9167 15.5833V16.5C11.9167 17.0069 11.5069 17.4167 11 17.4167C10.4931 17.4167 10.0833 17.0069 10.0833 16.5V15.5833H9.83767C8.85958 15.5833 7.94658 15.0572 7.45617 14.2093C7.20225 13.7702 7.35258 13.2101 7.78983 12.9571C8.22892 12.7013 8.78992 12.8535 9.042 13.2907C9.20608 13.5749 9.51042 13.75 9.83675 13.75H11.9157C12.4218 13.75 12.8324 13.3393 12.8324 12.8333C12.8324 12.4868 12.584 12.1935 12.2421 12.1367L9.4545 11.6719C8.22433 11.4675 7.33242 10.4133 7.33242 9.16667C7.33242 7.6505 8.56625 6.41667 10.0824 6.41667V5.5C10.0824 4.994 10.4922 4.58333 10.9991 4.58333C11.506 4.58333 11.9157 4.994 11.9157 5.5V6.41667H12.1614C13.1395 6.41667 14.0525 6.94375 14.5429 7.79167C14.7968 8.22983 14.6465 8.78992 14.2093 9.04383C13.7693 9.29775 13.2092 9.14742 12.9571 8.70925C12.793 8.426 12.4887 8.25092 12.1623 8.25092H10.0833C9.57733 8.25092 9.16667 8.6625 9.16667 9.16758C9.16667 9.51408 9.41508 9.80742 9.757 9.86425L12.5446 10.329C13.7748 10.5334 14.6667 11.5876 14.6667 12.8343V12.8333Z",
    fill: "#FF8000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_4929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesIcon);
export default __webpack_public_path__ + "static/media/SalesIcon.f63fa2162d4bd94c73ea38dd2079343e.svg";
export { ForwardRef as ReactComponent };